import { createSlice } from '@reduxjs/toolkit';

export type AppState = {
    sessionExpiredAcknowledged: boolean;
};

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        hideSessionExpiredDialog: state => {
            state.sessionExpiredAcknowledged = true;
        },
    },
});
